(function() {

  class LinkList {
    constructor(element) {
      if(!element || element.classList.contains('u-module--initialized')) return;

      element.classList.add('u-module--initialized');

      this.element = element;
      this.init();
    }

    init() {
      const showMore = this.element.querySelector('.u-link-list__show-more');
      if(showMore) {
        showMore.addEventListener('click', () => {
          this.element.classList.add('u-link-list--show-hidden')
        });
      }
      
      const showLess = this.element.querySelector('.u-link-list__show-less');
      if (showLess) {
        showLess.addEventListener('click', () => {
          this.element.classList.remove('u-link-list--show-hidden')
        });
      }
    }
  }

  function initAll(parent) {
    const elements = parent.querySelectorAll('.u-link-list');

    for (const element of elements) {
      new LinkList(element)
    }
  }

  document.addEventListener('DOMContentLoaded', function () {
    initAll(document);
  });

  document.addEventListener('overlay-content-ready', function () {
    initAll(document.querySelector('.u-overlay__content'));
  });

})();